import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import { CourseIncludes } from '@/features/course-landing-page/components/course-includes/course-includes.react-component';
import { AsyncStaticPriceText } from '@udemy-v2/react-course-pricing';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { useConsumerSubscriptionGwGPlan, useConsumerSubscriptionGwGPlusPersonalPlan } from '@udemy-v2/subscription-graphql';
import { GwgEnrollmentCTA } from '@udemy-v2/career-accelerators';
import { useI18n } from '@udemy-v2/i18n';
import { useCourseCareerAccelerator } from '@/features/course-landing-page/context/career-accelerator-provider.react-component';
import { CourseContentPlacement } from '../../course-landing-page.react-component';
import styles from './enrollment-box.module.scss';
import { useUserHasOrganization } from "@/lib/hooks/use-user-has-organization";
interface EnrollmentBoxProps {
  placement: CourseContentPlacement;
}

/**
 * EnrollmentBox component displays the enrollment CTA for courses in a user's subscription or free courses.
 * Note: If a PP user has is marked as enrolled in the course, we'll still show this CTA to them since there's no difference
 * in the user experience between the first and subsequent visits to CLP for PP users.
 */
export const EnrollmentBox = t0 => {
  const $ = _c(16);
  const {
    placement
  } = t0;
  const {
    gettext
  } = useI18n();
  const course = useClpCourse();
  const hasOrganization = useUserHasOrganization();
  const {
    isCourseIncludedInUserSubscription
  } = useClpPurchaseContext();
  const hidePrice = isCourseIncludedInUserSubscription || hasOrganization;
  const gwgPlan = useConsumerSubscriptionGwGPlan();
  const gwgPlusPersonalPlan = useConsumerSubscriptionGwGPlusPersonalPlan();
  const courseCareerAccelerator = useCourseCareerAccelerator();
  const isSubscribedToGwG = gwgPlan && "isSubscriber" in gwgPlan && gwgPlan.isSubscriber || gwgPlusPersonalPlan && "isSubscriber" in gwgPlusPersonalPlan && gwgPlusPersonalPlan.isSubscriber;
  const shouldShowGwgEnrollmentCTA = !course.isEnrolled && isSubscribedToGwG && courseCareerAccelerator?.id;
  const isSidebarPlacement = CourseContentPlacement.SIDEBAR === placement;
  const t1 = !isSidebarPlacement;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames(styles.container, {
      [styles["container--with-margin"]]: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== course.id || $[3] !== hidePrice) {
    t3 = !hidePrice && <AsyncStaticPriceText listPriceClassName="ud-heading-lg" courseId={Number(course.id)} />;
    $[2] = course.id;
    $[3] = hidePrice;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== courseCareerAccelerator || $[6] !== gettext || $[7] !== shouldShowGwgEnrollmentCTA) {
    t4 = shouldShowGwgEnrollmentCTA ? <GwgEnrollmentCTA udStyle="primary" acceleratorId={Number(courseCareerAccelerator.id)} unEnrolledSubtitle={gettext("You will be enrolled in all courses included in this path.")} /> : <ClpPrimaryCtaButton udStyle="primary" />;
    $[5] = courseCareerAccelerator;
    $[6] = gettext;
    $[7] = shouldShowGwgEnrollmentCTA;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isSidebarPlacement) {
    t5 = isSidebarPlacement && <CourseIncludes />;
    $[9] = isSidebarPlacement;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t2} data-purpose="enrollment-box">{t3}{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};